<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs4>
                <h1>Delayed Tasks</h1>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    @input="updateRows"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs8 class="text-right">
                <v-btn color="primary mr-2" dark @click="createJobTaskCallback()">Add Task</v-btn>
                <v-btn color="primary ml-2" outlined dark to="/management/tasks/active">Active</v-btn>
                <v-btn color="green ml-2" dark :to="'/management/tasks/completed'">Completed</v-btn>
                <v-btn color="neutral ml-2" dark :to="'/management/tasks/archived'">Archived</v-btn>
                <v-btn color="purple ml-2" dark :to="'/management/tasks/inprogress'">In Progress</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="displayTasks"
                        item-key="name"
                        :server-items-length="numDisplayTasks"
                        :options.sync="options"
                        class="elevation-1 task-table">
                        <template v-slot:item.action="{ item }">
                            <v-row >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            class="mr-2"
                                            color="primary"
                                            @click="handleDetails(item)">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>Task Details</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            class="mr-2"
                                            color="grey"
                                            @click="archiveDialogForJobTask(item)">
                                            mdi-archive
                                        </v-icon>
                                    </template>
                                    <span>Archive Task</span>
                                </v-tooltip>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <add-jobTask
            :showDialog="createJobTaskDialog"
            :toggle="toggleCreate">
        </add-jobTask>

        <update-status
            :showDialog="delayJobTaskDialog"
            :toggle="toggleDelayed"
            :jobTask="jobTaskToDelay">
        </update-status>

        <archive-jobTask
            :showDialog="archiveJobTaskDialog"
            :toggle="toggleArchive"
            :jobTask="jobTaskToArchive">
        </archive-jobTask>
        <jobTask-details
            :showDialog="detailsJobTaskModal"
            :toggle="toggleDetails"
            :jobTask="jobTaskForDetails">
        </jobTask-details>

    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Helpers from  '@/utils/helpers/jobTaskHelpers'
    import AddJobTask from '@/components/jobTasks/Add'
    import UpdateStatus from '@/components/jobTasks/UpdateStatus'
    import ArchiveJobTask from '@/components/jobTasks/Archive'
    import JobTaskDetails from  '@/components/jobTasks/Details'
    export default {
        name: 'DelayedTasks',
        components: {
            AddJobTask,
            UpdateStatus,
            ArchiveJobTask,
            JobTaskDetails
        },
        created () {
            this.getDelayedJobTaskRange({keywords: '', limit: 10, offset: 0})
            this.getDelayedCount()
        },
        data () {
            return {
                archiveJobTaskDialog: false,
                delayJobTaskDialog: false,
                createJobTaskDialog: false,
                detailsJobTaskModal: false,
                index: null,
                jobTaskToArchive: {},
                jobTaskToDelay: {},
                jobTaskForDetails: {},
                routes: [],
                search: '',
                options: {},
                displayTasks: [],
                numDisplayTasks: 0,
            }
        },

        methods: {
            ...mapActions({
                getDelayedJobTaskRange: 'jobTasks/getDelayedRange',
                getDelayedCount: 'jobTasks/getDelayedCount',
                getTask: 'jobTasks/getById'
            }),
            createJobTaskCallback() {
                this.createJobTaskDialog = true;
            },
            toggleCreate() {
                if(this.createJobTaskDialog){
                    this.updateRows()
                }
                this.createJobTaskDialog = !(this.createJobTaskDialog)
            },
            toggleDelayed() {
                if(this.delayedJobTaskDialog){
                    this.updateRows()
                }
                this.delayedJobTaskDialog = !(this.delayedJobTaskDialog)
            },
            toggleArchive() {
                if(this.archiveJobTaskDialog){
                    this.updateRows()
                }
                this.archiveJobTaskDialog = !(this.archiveJobTaskDialog)
            },
            toggleDetails() {
                if(this.detailsJobTaskModal){
                    this.updateRows()
                }
                this.detailsJobTaskModal = !(this.detailsJobTaskModal)
            },
            archiveDialogForJobTask(item) {
                this.jobTaskToArchive = item.jobTask
                this.toggleArchive()
            },
            delayDialogForJobTask(item) {
                this.jobTaskToDelay = item.jobTask
                this.toggleDelayed()
            },
            handleDetails(item) {
                this.jobTaskForDetails = item.jobTask
                this.getTask(item.jobTask.id)
                this.toggleDetails()
            },
            updateRows(){
                let limit = this.options.itemsPerPage
                let offset = this.options.itemsPerPage * (this.options.page - 1)
                //picking 'all' sets limit to -1 so we can handle that here
                if(limit < 0){
                    limit = this.delayedCount
                    offset = 0
                }
                this.getDelayedCount()
                this.getDelayedJobTaskRange({keywords: this.search, limit: limit, offset: offset})
            }
        },
        computed: {
            ...mapGetters({
                headers: 'jobTasks/headers',
                error: 'jobTasks/error',
                jobTaskRange: 'jobTasks/delayedTaskRange',
                delayedCount: 'jobTasks/delayedCount',
            }),

        },
        watch: {
            options: {
                handler () {
                   this.updateRows()
                },
                deep: true,
            },
            jobTaskRange: {
                handler() {
                    this.displayTasks = Helpers.display(this.jobTaskRange)
                    this.numDisplayTasks = this.delayedCount
                },
                deep: true
            },
            delayedCount: function (){
                this.numDisplayTasks = this.delayedCount
            }
        },
    }
</script>

<style>
    .task-table{
        table-layout : fixed;
    }
</style>
